<template>
    <div class="m-message">
        <div class="title_wrap">
            <p class="page_title">{{ $t('my.message') }}</p>
            <div
                v-if="status==='detail'"
                class="btn_group"
            >
                <el-button
                    class="primary_btn"
                    @click="back"
                >{{ $t('my.back') }}</el-button>
            </div>
        </div>
        <div
            v-if="status==='list'"
            v-loading="loading"
        >
            <ul
                v-if="list.length > 0"
                class="list"
            >
                <li
                    v-for="(item, index) in list"
                    :key="index"
                    class="list_item"
                    @click="toDetail(item,index)"
                >
                    <p class="title">{{ item.title }}</p>
                    <p
                        class="desc"
                        v-html="item.content"
                    />
                    <p class="creat_at">{{ item.created_at }}</p>
                    <p class="stauts_wrap">
                        <span :class="{'actived':!item.is_read}">{{ item.is_read ? '已读' :'未读' }}</span>
                        <i class="iconfont icon-you" />
                    </p>
                </li>
            </ul>
            <div
                v-else
                class="nodatawrap"
            >
                <img
                    src="../../../assets/images/nodata.png"
                    alt=""
                    class="nodata"
                >
                <p>{{ $t('my.nodata') }}</p>
            </div>
            <pagination
                v-show="total>0"
                :total="total"
                :page.sync="listQuery.page"
                :limit.sync="listQuery.limit"
                @pagination="getList"
            />
        </div>
        <div
            v-else
            v-loading="loading"
            class="content"
        >
            <h1>{{ detail.title }}</h1>
            <p v-html="detail.content" />
        </div>

    </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import { noticeList, noticeDetail } from '@/api/notice'

export default {
    name: 'MessageList',
    directives: {},
    components: { Pagination },
    data() {
        return {
            list: [],
            total: 0,
            listQuery: {
                page: 1,
                limit: 10
            },
            loading: false,
            status: 'list',
            currentItem: '',
            currentIndex: -1,
            detail: ''
        }
    },

    created() {
        this.getList()
    },

    methods: {
        getList() {
            this.loading = true
            noticeList(this.listQuery).then(res => {
                if (res.code === 200) {
                    this.list = res.data.list
                    this.total = res.data.total

                    this.loading = false
                }
            }).catch(() => { this.loading = false })
        },

        toDetail(item, index) {
            this.status = 'detail'
            this.currentItem = item
            this.currentIndex = index
            this.getDetail()
            // this.$router.push({ path: '/messageDetail', query: { tid: this.tid, id: item.id }})
        },

        getDetail() {
            this.loading = true
            noticeDetail({ id: this.currentItem.id }).then(res => {
                this.loading = false
                if (res.code === 200) {
                    this.detail = res.data.info
                }
            }).catch(() => { this.loading = false })
        },

        back() {
            this.list[this.currentIndex].is_read = 1
            this.status = 'list'
        }

    }
}
</script>
<style rel="stylesheet/scss" lang="scss">
.m-message {
    .title_wrap {
        height: 100px;
        border-bottom: 1px solid #eeeeee;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .page_title {
            line-height: 100px;
            font-weight: 400;
            font-size: 24px;
            color: #333;
        }

        .btn_group {
            .primary_btn {
                height: 33px;
            }
        }
    }

    .list {
        margin-top: 22px;

        .list_item {
            padding: 20px 28px;
            text-align: left;
            position: relative;
            border-bottom: 1px solid #eee;
            cursor: pointer;

            .title {
                margin-bottom: 10px;
                font-family: PingFang;
                font-size: 18px;
                font-weight: 600;
                color: #333333;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                line-clamp: 1;
                -webkit-box-orient: vertical;
            }

            .desc {
                margin-bottom: 10px;
                font-family: PingFang SC;
                font-size: 14px;
                font-weight: 400;
                color: #666666;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1;
                line-clamp: 1;
                -webkit-box-orient: vertical;
            }

            .creat_at {
                font-size: 12px;
                font-weight: 400;
                color: #999999;
            }

            .stauts_wrap {
                position: absolute;
                bottom: 18px;
                right: 15px;
                font-size: 14px;
                color: #999999;

                .actived {
                    color: #c72b1e;
                }

                .img_arrow {
                    font-size: 8px;
                    padding-left: 4px;
                }
            }
        }
    }

    h1 {
        padding: 20px 0;
        text-align: center;
        font-size: 19px;
        font-weight: 600;
    }
    .content {
        text-align: left;
        padding: 0 15px 10px;
        word-break: break-word;
        white-space: normal;
        p {
            text-indent: 16px;
            text-align: left;
            line-height: 28px;
            font-size: 14px;
        }
    }
}

.nodatawrap {
    text-align: center;
}
</style>
